import {
  useCreateTag,
  useUpdateTag,
} from 'scenes/Gallery/ConversionPages/ConversionPages/data';

import TagForm from './TagForm';
import { NAME } from './constants';

export const TagFormCreate = (props) => {
  const [createTag, { isLoading }] = useCreateTag();

  const handleSubmit = async (values) => {
    const response = await createTag(values);
    props.onSubmit(response);
  };

  return (
    <TagForm
      {...props}
      title={'Add Tag'}
      onSubmit={handleSubmit}
      loading={isLoading}
    />
  );
};

export const TagFormUpdate = ({ id, name, onClose, ...props }) => {
  const [updateTag, { isLoading }] = useUpdateTag();

  const handleSubmit = async (values) => {
    await updateTag(values);
    onClose();
  };

  return (
    <TagForm
      {...props}
      title={'Edit Tag'}
      loading={isLoading}
      onClose={onClose}
      onSubmit={handleSubmit}
      initialValues={{
        id,
        [NAME]: name,
      }}
    />
  );
};
